import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merge Detail|Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMergeDetailsExams';
export type SPCandidateSystemActivityMergeDetailsExamsLocNames =
	| `${LocNameStart}LabelDate`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelCode`
	| `${LocNameStart}LabelRegistration`
	| `${LocNameStart}LabelGrade`;

export const spCandidateSystemActivityMergeDetailsExamsLocs: LocDefs<SPCandidateSystemActivityMergeDetailsExamsLocNames> =
	{
		SPCandidateSystemActivityMergeDetailsExamsLabelDate: {
			defaultValue: 'Date',
			description: 'Label for: Date.',
			displayPath: `${pathStart}Date`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ExamTable.ColumnHeading.Date',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsExamsLabelName: {
			defaultValue: 'Name',
			description: 'Label for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ExamTable.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsExamsLabelCode: {
			defaultValue: 'Code',
			description: 'Label for: Code.',
			displayPath: `${pathStart}Code`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ExamTable.ColumnHeading.Code',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsExamsLabelRegistration: {
			defaultValue: 'Registration',
			description: 'Label for: Registration.',
			displayPath: `${pathStart}Registration`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ExamTable.ColumnHeading.Registration',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsExamsLabelGrade: {
			defaultValue: 'Grade',
			description: 'Label for: Grade.',
			displayPath: `${pathStart}Grade`,
			displayType: 'Title',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.ExamTable.ColumnHeading.Grade',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergeDetailsExamsLocType =
	LocMap<SPCandidateSystemActivityMergeDetailsExamsLocNames>;
